import { Funcionalidade } from "../util/enum/funcionalidade.enum";

const Dashboard = {
    text: 'Dashboard',
    link: '/dashboard',
    icon: 'fa fa-bar-chart',
    funcionalidade: Funcionalidade[Funcionalidade.DASHBOARD]
};

const Backups = {
  text: 'Backups',
  link: '/backups',
  icon: 'fa fa-cloud-upload',
  funcionalidade: Funcionalidade[Funcionalidade.CADASTRO_DE_BACKUPS]
};

const UltimosBackups = {
  text: 'Ultimos Backups',
  link: '/ultimosBackups',
  icon: 'fa fa-cloud-upload',
  funcionalidade: Funcionalidade[Funcionalidade.CADASTRO_DE_BACKUPS]
};

const Restauracoes = {
  text: 'Restauracoes',
  link: '/restauracoes',
  icon: 'fa fa-refresh',
  funcionalidade: Funcionalidade[Funcionalidade.CONSULTA_DE_RESTORES]
};

const Planos = {
  text: 'Planos',
  link: '/planos/listagemPlano',
  icon: 'fa fa-server',
  funcionalidade: Funcionalidade[Funcionalidade.CADASTRO_DE_PLANOS]
};

/*const ExportacaoDeDados = {
  text: 'Exportação de dados',
  link: '/exportacaoDeDados',
  icon: 'fa fa-code',
  funcionalidade: Funcionalidade[Funcionalidade.EXPORTACAO_DE_DADOS]
};*/

const Usuarios = {
  text: 'Usuarios',
  link: '/usuarios/listagemUsuario',
  icon: 'fa fa-users',
  funcionalidade: Funcionalidade[Funcionalidade.CADASTRO_DE_USUARIOS]
};

const Empresas = {
  text: 'Empresas',
  link: '/empresas/listagemEmpresa',
  icon: 'fa fa-building',
  funcionalidade: Funcionalidade[Funcionalidade.CADASTRO_DE_EMPRESAS]
};

const EmpresasInativasComBackup = {
  text: 'Empresas Inativas c/ Bkp.',
  link: '/empresas/inativasComBackup',
  icon: 'fa fa-building',
  funcionalidade: Funcionalidade[Funcionalidade.CADASTRO_DE_EMPRESAS]
};

const Configuracao = {
  text: 'Configuracao',
  link: '/configuracao',
  icon: 'fa fa-cogs',
  funcionalidade: Funcionalidade[Funcionalidade.CONFIGURACAO]
};

const ConsultaDeLog = {
  text: 'Consulta de Log',
  link: '/consultaDeLog',
  icon: 'fa fa-file-text-o',
  funcionalidade: Funcionalidade['Consulta de Log']
};

const headingMain = {
    text: 'Main Navigation',
    heading: true
};

export const menu = [
    Dashboard,
    Backups,
    //UltimosBackups,
    Restauracoes,
    Planos,
    Usuarios,
    Empresas,
    EmpresasInativasComBackup,
    Configuracao,
    ConsultaDeLog
];



// WEBPACK FOOTER //
// ./src/app/routes/menu.ts